import { ApiClient } from "@/api-client/src/core/api-client";
import { PageApiResponse, PageData, PagesListApiResponse } from "@/packages/types/page";

const apiClient = new ApiClient();
const webService = apiClient.web;

export const fetchPagesByslug = async (slug: string): Promise<PageData> => {
  const response = await webService.get<PageApiResponse>(`/pages/${slug}`);
  return response.data;
};

export const fetchAllPages = async (): Promise<PagesListApiResponse["data"]> => {
  const response = await webService.get<PagesListApiResponse>(`/pages`);
  return response.data;
};
